import React from "react";
import { useNavigate } from "react-router";

const SurveyInvalidScreen = () => {
  const navigate = useNavigate();

  return (
    <>
      <h2 className="text-center">
        La encuesta a la que intenta acceder no se encuentra en nuestros registros.
      </h2>
      <div className="text-center mt-4">
        <button onClick={() => navigate("/")} className="btn btn-primary btn-lg">
          Volver
        </button>
      </div>
    </>
  );
};

export default SurveyInvalidScreen;
